<div class="header">
  <div class="title">Quick Calculator</div>
  <ts-button
    class="close-button"
    type="icon"
    htmlButtonType="button"
    icon="ts_close"
    (buttonClick)="discard()"
    [tabIndex]="-1"
  ></ts-button>
</div>
<div class="flex flex-auto">
  <div class="flex flex-col w-1/2 left-panel">
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Purchase Price</mat-label>
        <input
          matInput
          [(ngModel)]="underwriting.purchasePrice"
          (ngModelChange)="onChange()"
          currencyMask
          [options]="currencyMaskOptions"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>NOI</mat-label>
        <input
          matInput
          [(ngModel)]="underwriting.noi"
          (ngModelChange)="onChange()"
          currencyMask
          [options]="currencyMaskOptions"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Cap Rate</mat-label>
        <span matSuffix>%</span>
        <input matInput [(ngModel)]="underwriting.capRate" (ngModelChange)="onChangeCapRate()" />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Leverage (%)</mat-label>
        <span matSuffix>%</span>
        <input matInput [(ngModel)]="underwriting.leverage" (ngModelChange)="onChange()" />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Interest Rate</mat-label>
        <span matSuffix>%</span>
        <input matInput [(ngModel)]="underwriting.interestRate" (ngModelChange)="onChange()" />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Amoritization Period (Years)</mat-label>
        <input matInput [(ngModel)]="underwriting.term" (ngModelChange)="onChange()" />
      </mat-form-field>
    </div>
  </div>
  <div class="flex flex-col w-1/2 right-panel">
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Equity Required</mat-label>
        <input
          matInput
          [(ngModel)]="underwriting.equityRequired"
          disabled
          currencyMask
          [options]="currencyMaskOptions"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Cap Rate</mat-label>
        <span matSuffix>%</span>
        <input matInput [ngModel]="underwriting.capRate / 100 | percent: '1.2-2'" disabled />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Net Cash Flow</mat-label>
        <input matInput [(ngModel)]="underwriting.netCashFlow" disabled currencyMask [options]="currencyMaskOptions" />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>Cash on Cash</mat-label>
        <span matSuffix>%</span>
        <input matInput [ngModel]="underwriting.cashOnCash / 100 | percent: '1.2-2'" disabled />
      </mat-form-field>
    </div>
    <div class="flex flex-col gt-xs:flex-row mt-3">
      <mat-form-field class="subject flex-auto">
        <mat-label>DSCR</mat-label>
        <span matSuffix>x</span>
        <input matInput [ngModel]="underwriting.dscr / 100 | percent: '1.2-2'" disabled />
      </mat-form-field>
    </div>
  </div>
</div>
